import React from "react"
import { WorkshopTextImageButtonType } from "../../types/mainModulTypes"
import { API } from "../../constants/constants"
import PrimaryButton from "../common/PrimaryButton"
import BaseHeadline from "../common/BaseHeadline"
import BaseSubheadline from "../common/BaseSubheadline"
import BaseRichtext from "../common/BaseRichtext"
import { useNavigate } from "react-router-dom"

export default function WorkshopTextImageButton(props: WorkshopTextImageButtonType) {
    const navigate = useNavigate()
    return (
        <div className="max-w-content mx-auto text-center pb-4 px-4 lg:px-0">
            <div className="max-w-content-sm mx-auto">
                <BaseHeadline headlineType={3} label={props.workshopTextImageButtonHeading} />
                <BaseSubheadline label={props.workshopTextImageButtonSubHeading} classProps="pb-2" />
                <BaseRichtext content={props.workshopTextImageButtonText} classProps="pb-6" />
            </div>
            <div className="w-full relative">
                <img
                    src={API + props?.workshopTextImageButtonImage?.url}
                    alt={props.workshopTextImageButtonImage?.description ?? props.workshopTextImageButtonImage?.name ?? "WerkstattAltTag"}
                    className="aspect-video w-full object-cover rounded-default"
                />
                <div className="absolute bottom-0 translate-y-1/2 flex w-full items-center justify-center px-4 sm:px-0">
                    <PrimaryButton
                        text={props?.workshopTextImageButtonButton}
                        onClick={() => {
                            if (props.workshopTextImageButtonUrl.includes("https://")) {
                                window.open(props.workshopTextImageButtonUrl, "_blank")
                            } else {
                                navigate(props.workshopTextImageButtonUrl)
                            }
                        }}
                        active={props?.workshopTextImageButtonToggle}
                        classProps="w-full sm:w-fit"
                    />
                </div>
            </div>
        </div>
    )
}
